import { createSelector } from '@ngrx/store';
import { freeProductsImagesState } from '../root';

export const getFreeProductsImageByProductId = (productId: number) => createSelector(
    freeProductsImagesState,
    freeProductsImages => freeProductsImages.find(obj => obj.ProductId === productId) || null
);
